/*
  Copied from: https://github.com/twickstrom/vue-force-next-tick
  Issue on Vue about Vue.$nextTick not always waiting for the browser to render:
  https://github.com/vuejs/vue/issues/9200

  On double requestAnimationFrame:
  https://stackoverflow.com/a/44700302/5993042
 */

const doubleRequestAnimationFrame = (callback: () => void) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(callback);
  });
};

// Run a function when we're sure the browser has rendered the HTML
// nextTick doesn't guarantee this. Only that the browser is aware it needs to do the change.
export const forceNextTick = (callback: () => void) => {
  doubleRequestAnimationFrame(callback);
};

// Promise-based version that can be awaited
export const forceNextTickAsync = (callback: () => void): Promise<void> => {
  return new Promise((resolve) => {
    doubleRequestAnimationFrame(() => {
      callback();
      resolve();
    });
  });
};
